import { StyledEngineProvider } from "@mui/material/styles";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./appInsights";
import { ThemeModeProvider } from "./common/contexts/themeModeContext";
import "./index.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId="39529496540-fdg75o161eaev57okg3h2nffpr4kjhfs.apps.googleusercontent.com">
    {/* injectFirst: MUI injects its base styles before our SCSS, so plain
        class styles reliably override MUI component defaults (margins, Button,
        Card, Avatar, etc.) without needing !important. */}
    <StyledEngineProvider injectFirst>
      <ThemeModeProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </ThemeModeProvider>
    </StyledEngineProvider>
  </GoogleOAuthProvider>
);
